import PropTypes from 'prop-types';
import React, { createContext, useContext, useState } from 'react';

interface InitialState {
  error: {
    code: number;
    message: string;
    details?: string;
  };
  backButton: {
    label: string;
  };
}

const defaultValues = {
  error: {
    code: 500,
    message: '',
    details: '',
  },
  backButton: {
    label: '',
  },
};

const InitialStateContext = createContext<InitialState>(defaultValues);

const useInitialState = () => useContext(InitialStateContext);

const InitialStateProvider = ({ children }) => {
  const [state] = useState((window as any).state);

  return (
    <InitialStateContext.Provider value={state}>
      {children}
    </InitialStateContext.Provider>
  );
};

InitialStateProvider.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.array])
    .isRequired,
};

export { InitialStateContext, InitialStateProvider, useInitialState };
